<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Button from '@/comps-sdk/components/button';

  export let receiveResult: any = {};

  $: showResult = receiveResult?.showResult;
  $: successCount = receiveResult?.showResult?.customData?.presentsInfo?.length || 0;
  $: successMode = receiveResult?.code === 0;
  $: errorMsg = receiveResult?.msg ?? '领取失败了，请稍后再试～';
  $: presentInfo = receiveResult?.showResult?.customData?.presentsInfo?.[0] || {
    presentTitle: '',
    presentDesc: '',
  };

  const dispatch = createEventDispatcher();

  const handleBtnClick = () => {
    dispatch('close');
  };
  const handleViewAllGift = () => {
    dispatch('view-all-gift');
  };
</script>

<div class="result-panel">
  <div class="result-header">
    {showResult?.title}
  </div>
  <div class="result-content">
    <div class="present-wrapper" class:error-mode={!successMode}>
      {#if !successMode}
        <div class="error-wrapper">
          {errorMsg}
        </div>
      {:else}
        <div class="present-info" class:single-gift={successCount === 1}>
          <div class="present-name">
            {presentInfo.presentTitle}
          </div>
          <div class="present-desc">
            {presentInfo.presentDesc}
          </div>
        </div>
        {#if successCount !== 1}
          <div class="more-btn">
            <Button mode="small" on:click={handleViewAllGift}>查看全部</Button>
          </div>
        {/if}
      {/if}
    </div>
    {#if showResult.img}
      <div class="result-img-wrapper">
        <img class="result-img" alt="" src={showResult.img} />
      </div>
    {/if}
  </div>

  <div class="btn-wrapper">
    <Button on:click={handleBtnClick}>
      {showResult?.btnText || '我知道了'}
    </Button>
  </div>
</div>

<style lang="scss">
  .result-panel {
    padding: 0 15px;
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    .result-header {
      margin-top: 15px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #191919;
    }
    .result-content {
      flex: 1;
      margin: 12px 0;
      .present-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 12px;
        &.error-mode {
          justify-content: center;
        }
        .present-info {
          flex: 1;
          text-align: left;
          &.single-gift {
            width: 100%;
            text-align: center;
          }
          .present-name {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #191919;
          }
          .present-desc {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: rgba(25, 25, 25, 0.5);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100%;
          }
        }
        .more-btn {
          margin-left: 6px;
        }
      }
      .result-img-wrapper {
        margin-top: 24px;
        text-align: center;
        .result-img {
          width: auto;
          max-width: 100%;
          max-height: 140px;
          border-radius: 6px;
        }
      }
    }
    .btn-wrapper {
      margin: 10px 0;
      text-align: center;
    }
  }
</style>
